/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: supportstrip.js
 */

/**
 * Load support strip link lists
 */

$.namespace("SCS.supportstrip");

SCS.supportstrip.placeholder = '_keyword_';
SCS.supportstrip.NA = 'NA'; //base64 url safe encoded

// still used on PROD (19 instances)
SCS.supportstrip.init = function (id) {

	$("#" + id + " .links").each(function () {
		var $this = $(this);
		var url = $this.data("url");
		if (url) {
			url = url.replace(SCS.supportstrip.placeholder, $.base64.encode(SCS.supportstrip.NA).replace('=', '')); // URL Safe version of Base64

			$this.load(url, function (response, status, xhr) {
				if (status != "success" && status != "notmodified") {
					$this.hide();
				}
			});
		}
	});

	$("#" + id + " form").on("submit", function (e) {
		var actionUrl = $(this).attr("action");
		var term = escape($("#searchTerm").val());
		var url = actionUrl + "#.$[TERM].$".replace("[TERM]", term);
		window.location.href = url;

		e.preventDefault();
	});

	SCSC.forms.placeholder(); // TODO try to get rid of this call to legacy code
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/supportstrip.js
// module id = 117
// module chunks = 0